import Asignatura from "./asginatura";
import Horarios from "./horarios";
import Aulas from "./aulas";
import Notas from "./nnotas";
import NotasA from "./notasa";
import PNotas from "./procesosnotas";
import ControlEstudio from "./control de estudio";
import DNotas from "./control de estudio/dnotas";

export const colegio_academico_pantallas={
    Asignaturas:Asignatura,
    Horario:Horarios,
    Aulas,
    DNotas,
    Notas,
    notasA:NotasA,
    procesosnotas:PNotas,
    ControlEstudio
}